/**
 * Enquiry display utilities
 * UI-only computed status and date logic. Does not modify backend data.
 */

import dayjs from 'dayjs';

/**
 * Get local date-only (strip time) for comparison to avoid timezone issues.
 * @param {string|Date|dayjs.Dayjs} date
 * @returns {dayjs.Dayjs|null} dayjs in local date-only or null
 */
const toLocalDate = (date) => {
  if (!date) return null;
  const d = dayjs(date);
  return d.isValid() ? d.startOf('day') : null;
};

/**
 * UI-only display status for enquiry table/cards.
 * If next_follow_up_on exists and is before today, show "Follow Up Missed" and isMissed: true.
 * Otherwise show actual enquiry.status and isMissed: false.
 *
 * @param {{ status?: string, next_follow_up_on?: string | null }} enquiry
 * @returns {{ label: string, isMissed: boolean }}
 */
export const getDisplayStatus = (enquiry) => {
  if (!enquiry) return { label: '', isMissed: false };

  const today = toLocalDate(new Date());
  const followUpDate = toLocalDate(enquiry.next_follow_up_on);

  if (followUpDate && today && followUpDate.isBefore(today)) {
    return { label: 'Follow Up Missed', isMissed: true };
  }

  return {
    label: enquiry.status || '',
    isMissed: false,
  };
};
